// data/bidangDummy.js
export const bidangDummy = [
  { id: 1, nama: "Kementrian Koordinator Bidang Politik & Keamanan" },
  { id: 2, nama: "Kementerian Koordinator Bidang Hukum, Hak Asasi Manusia, Imigrasi, dan Pemasyarakatan" },
  { id: 3, nama: "Kementrian Koordinator Bidang Perekonomian" },
  { id: 4, nama: "Kementerian Koordinator Bidang Pembangunan Manusia dan Kebudayaan" },
  { id: 5, nama: "Kementerian Koordinator Bidang Infrastruktur & Pembangunan Kewilayahan" },
  { id: 6, nama: "Kementerian Koordinator Bidang Pemberdayaan Masyarakat" },
  { id: 7, nama: "Kementerian Koordinator Bidang Pangan" },
  { id: 8, nama: "Kementerian Keuangan" },
  { id: 9, nama: "Kementerian Sekretariat Negara" },
  { id: 10, nama: "Kementerian  Perancangan Pembangunan Nasional" },
  { id: 11, nama: "Kementerian  Pendayagunaan Aperatur Negara & Reformasi Birokrasi" },
];
